import svg4everybody from 'svg4everybody';

import initSlider from './components/initSlider';
import Filters from './components/Filters';
import { initToggles, initFormToggles } from './util/toggle';


window.onload = function onLoad() {
    initToggles(document.querySelectorAll('.js-toggle-open'));
    initFormToggles(document.querySelectorAll('.js-toggle-form'));
    initSlider();
    Filters.init();

    svg4everybody();
};
